window.dataLayer = window.dataLayer || [];

export default function gtag() {
  window.dataLayer.push(arguments);
}
